/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { defineComponent, h } from 'vue';
import { rest } from './utils';
export const VALUES = "STORIES_VALUES";
/*
  This normalizes a functional component into a render method in ComponentOptions.

  The concept is taken from Vue 3's `defineComponent` but changed from creating a `setup`
  method on the ComponentOptions so end-users don't need to specify a "thunk" as a decorator.
 */
function normalizeFunctionalComponent(options) {
    return typeof options === 'function' ? { render: options, name: options.name } : options;
}
/**
 * Currently StoryContextUpdates are allowed to have any key in the type.
 * However, you cannot overwrite any of the build-it "static" keys.
 *
 * @param inputContextUpdate StoryContextUpdate
 * @returns StoryContextUpdate
 */
export function sanitizeStoryContextUpdate(inputContextUpdate) {
    return rest(inputContextUpdate, ["componentId", "title", "kind", "id", "name", "story", "parameters", "initialArgs", "argTypes"]);
}
function prepare(rawStory, innerStory) {
    const story = rawStory;
    if (story == null) {
        return null;
    }
    if (innerStory) {
        return Object.assign(Object.assign({}, normalizeFunctionalComponent(story)), { components: Object.assign(Object.assign({}, (story.components || {})), { story: innerStory }) });
    }
    return {
        render() {
            return h(story);
        },
    };
}
function decorateStory(storyFn, decorators) {
    return decorators.reduce((decorated, decorator) => (context) => {
        let story;
        const decoratedStory = decorator((update) => {
            story = decorated(Object.assign(Object.assign({}, context), sanitizeStoryContextUpdate(update)));
            return story;
        }, context);
        if (!story) {
            story = decorated(context);
        }
        if (decoratedStory === story) {
            return story;
        }
        return prepare(decoratedStory, story);
    }, (context) => prepare(storyFn(context)));
}
const StoryVueRenderer = defineComponent({
    name: "StoryVueRenderer",
    props: {
        story: Object,
    },
    render() {
        const story = this.story;
        console.log("StoryVueRenderer.story", story);
        if (story) {
            const storyFn = story.storyFn;
            const decorators = story.decorators || [];
            const context = {
                args: story.args || {},
                argTypes: {},
                parameters: {},
                initialArgs: {}
            };
            const r = decorateStory(storyFn, decorators);
            const r1 = r(context);
            console.log("rendering", r1);
            return h(r1);
        }
        return h("div", "No story selected");
    },
});
export default StoryVueRenderer;
//# sourceMappingURL=StoriesVueRenderer.js.map